import { View } from "@/features/common/components/tailwind/View";

export const JoinSubscriptionBoxView = (props) => {
  return (
    <View className="w-full flex flex-col items-center bg-gray-100 p-4 sm:p-10">
      {props.children}
    </View>
  );
};
